import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

/**
 * ページ遷移（URL変更）のたびにチャットボットを再実行する
 */
export const onRouteUpdate = () => {
  const containerId = "chatbot-runtime-container";
  
  const cleanup = () => {
    const oldContainer = document.getElementById(containerId);
    if (oldContainer) oldContainer.remove();
    const oldBotDiv = document.getElementById("chatbot");
    if (oldBotDiv) oldBotDiv.remove();
  };

  cleanup();

  // 1. 器を準備（最初は透明にしておく）
  const botDiv = document.createElement("div");
  botDiv.id = "chatbot";
  botDiv.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 9999;
    opacity: 0;
    transition: opacity 0.8s ease;
  `;
  document.body.appendChild(botDiv);

  // 2. スクリプト注入
  const container = document.createElement("div");
  container.id = containerId;
  
  const input = document.createElement("input");
  input.type = "hidden";
  input.id = "client_id";
  input.value = "26411";
  container.appendChild(input);

  // 最後のスクリプトが読み終わったら表示をONにする
  const inject = (src, isLast = false) => {
    const script = document.createElement("script");
    script.src = `${src}${src.includes('?') ? '&' : '?'}v=1`; // v=1に固定して少しキャッシュを効かせる
    script.async = false;

    if (isLast) {
      script.onload = () => {
        // スクリプト読み込み完了後、さらに少し待ってから表示（掲示板対策）
        setTimeout(() => {
          const target = document.getElementById("chatbot");
          if (target) target.style.opacity = "1";
        }, 100);
      };
    }
    container.appendChild(script);
  };

  // 設定用JS
  inject("https://www.takumi-dx.com/chatbot/js?client_id=26411");
  // 本体JS（こちらを最後に読み込む）
  inject("https://www.takumi-dx.com/assets/js/chatbot.js", true);

  document.body.appendChild(container);
};